export const InterpolationType = {
  NEAREST: 0,
  LINEAR: 1,
  FAST_LINEAR: 2,
};

export const OpacityMode = {
  FRACTIONAL: 0,
  PROPORTIONAL: 1,
};

export default {
  InterpolationType,
  OpacityMode,
};
